export function calculateRelevance(query, result) {
    const keywords = query.toLowerCase().split(' ');
    const content = `${result.title} ${result.snippet}`.toLowerCase();
    
    return keywords.reduce((score, keyword) => {
      const regex = new RegExp(keyword, 'g');
      const matches = (content.match(regex) || []).length;
      return score + matches;
    }, 0);
}

// Add the new monthsToFreshness function here
export function monthsToFreshness(months) {
  if (months <= 0)         return undefined; // let Bing decide
  if (months === 1)        return 'Month';   // Bing has no 'Months' plural
  if (months <= 6)         return 'Week';    // best available granularity
  return undefined;                        // >6 months → no freshness filter
}

export function simplifyQuery(query) {
  if (!query || typeof query !== 'string'
    ) {
    console.error('Invalid query received:', query);
    return '';
  }
  return query.replace(/["']/g, '');
}

export function buildSiteRestrictedQuery(query) {
  const allowedSites = ['pubmed.ncbi.nlm.nih.gov','www.cdc.gov','embase.com','webofscience.com','cochranelibrary.com','scholar.google.com','scopus.com','clinicaltrials.gov','apa.org','ncbi.nlm.nih.gov','ebscohost.com','sciencedirect.com','uptodate.com','jstor.org','lexisnexis.com','pedro.org.au','ovid.com','otseeker.com','dynamed.com','lilacs.bvsalud.org','jbi.global','cabdirect.org','tripdatabase.com','nature.com','cell.org'];
  const siteQueries = allowedSites.map(site => `site:${site}`).join(' OR ');
  return `${query} (${siteQueries})`;
}

// Remove the entire generateDateRangeString function below
/*
export function generateDateRangeString(months) {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - months);
  return `freshness:${startDate.toISOString().split('T')[0]}..${endDate.toISOString().split('T')[0]}`;
}
*/

export function updateLoadingStates(queryIndex, isLoading) {
  return (loadingStates) =>
    loadingStates.map((state, index) => index === queryIndex ? isLoading : state);
}